


export interface PartnersRegistrationState {
	showInvalids: boolean,
	contactPerson: string | null,
	clientName: string | null,
	email: string | null,
	phoneNumber: string | null,
	street: string | null,
	city: string | null,
	postalCode: string | null,
	invoiceStreet: string | null,
	invoiceCity: string | null,
	invoicePostalCode: string | null,
	registrationNumber: string | null,
	vatnumber: string | null,
	salesMan: string | null,
	message: string | null,
};

export const initialState: PartnersRegistrationState = {
	showInvalids: false,
	contactPerson: null,
	clientName: null,
	email: null,
	phoneNumber: null,
	street: null,
	city: null,
	postalCode: null,
	invoiceStreet: null,
	invoiceCity: null,
	invoicePostalCode: null,
	registrationNumber: null,
	vatnumber: null,
	salesMan: null,
	message: null,
};